module.exports = __webpack_public_path__ + "static/media/Hand.72a316c3.png";